import { render } from "./PopupProgressBar.vue?vue&type=template&id=b20dfc0e"
import script from "./PopupProgressBar.vue?vue&type=script&lang=js"
export * from "./PopupProgressBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__